import { render, staticRenderFns } from "./OsiguDrawer.vue?vue&type=template&id=8297ccb0"
import script from "./OsiguDrawer.vue?vue&type=script&lang=js"
export * from "./OsiguDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports